import BeatLoader from 'react-spinners/BeatLoader';
import { usePromiseTracker } from 'react-promise-tracker';
import { LOADER_DELAY_IN_MS } from '../Settings';
import { useLoadingContext } from '../contexts/LoadingContext';

function LoadingIndicator() {
    const loaderDelay = LOADER_DELAY_IN_MS;
    const { promiseInProgress } = usePromiseTracker({ delay: loaderDelay });
    const { firstLoadingInProgress } = useLoadingContext();

    const getClasses = ():string => {
        let classes = promiseInProgress || firstLoadingInProgress ? 'locker-plugin-show-loader' : 'locker-plugin-hide-loader'
        return classes.concat(" locker-plugin-loader-background");
    }

    return (<>
        <div className={getClasses()}>
            <div className="locker-plugin-beat-loader mx-auto my-auto">
                <BeatLoader color={"#ef0000"} size={30} />
            </div>
        </div>
    </>);
}

export default LoadingIndicator;